import { jsx as _jsx } from "react/jsx-runtime";
import { ArrowUpIcon } from './ArrowUpIcon';
export const ArrowDownIcon = (props) => (_jsx(ArrowUpIcon, { style: { transform: 'rotate(180deg)' }, ...props }));
